import { lazyPage, type ModulePlugin } from "@keel/core";
import { DepreciationTile } from "./Tile";

const reg = () => import("./Register");
const Register = lazyPage(reg, "Register");
const AssetPage = lazyPage(reg, "AssetPage");
const NewAsset = lazyPage(reg, "NewAsset");
const EmployeeAssets = lazyPage(reg, "EmployeeAssets");
const Depreciation = lazyPage(() => import("./Depreciation"), "Depreciation");
const AssetClasses = lazyPage(() => import("./Classes"), "AssetClasses");

/** Fixed assets (optional module): register, depreciation runs, asset classes. */
const plugin: ModulePlugin = {
  key: "assets",
  records: { FixedAsset: "/assets/" },
  help: () => import("./help"),
  nav: [
    {
      group: "Fixed assets",
      items: [
        { to: "/assets", label: "Asset register", icon: "building", perm: "assets.register.read", end: true },
        { to: "/depreciation", label: "Depreciation", icon: "chart", perm: "assets.register.read" },
        { to: "/asset-classes", label: "Asset classes", icon: "sliders", perm: "assets.register.read" },
      ],
    },
  ],
  routes: [
    { path: "/assets", element: <Register /> },
    { path: "/assets/new", element: <NewAsset /> },
    { path: "/assets/:id", element: <AssetPage /> },
    { path: "/depreciation", element: <Depreciation /> },
    { path: "/asset-classes", element: <AssetClasses /> },
  ],
  commands: [
    ["Asset register", "/assets", "building", "assets.register.read"],
    ["New fixed asset", "/assets/new", "plus", "assets.register.write"],
    ["Run depreciation", "/depreciation", "chart", "assets.register.read"],
  ],
  sources: { fixed_asset: "/assets/", depreciation_run: "/depreciation?run=" },
  employeeTabs: [{ key: "assets", label: "Assets", perm: "assets.register.read", component: EmployeeAssets }],
  dashboardTiles: [
    { key: "assets", section: "assets", perm: "assets.register.read", component: DepreciationTile },
  ],
};
export default plugin;
